import React from "react";
import "./ActionButtons.scss";
import TranslateComponent from "../../misc/translate/Translate.component";
import {DOWNLOAD_CSV, PRINT} from "../constants/NewCurrentOfferings";
import {REST_NEW_CURRENT_OFFERINGS} from "../../../constants/Rest.constants";

export default function ActionButtons({fetchParams}) {
  const handlePrint = () => {
    window.print();
  };
  const handleDownload = async () => {
    try {
      const baseUrl = `${REST_NEW_CURRENT_OFFERINGS}`;
      const params = new URLSearchParams();
      if (fetchParams.search) params.append("keyword", fetchParams.search);
      if (fetchParams.orderBy) params.append("orderBy", fetchParams.orderBy);
      if (fetchParams.descending) params.append("descending", true);
      params.append("language", fetchParams.language);

      Object.keys(fetchParams.filters).forEach((key) => {
        if (fetchParams.filters[key])
          params.append(key, fetchParams.filters[key]);
      });
      const url = params.toString()
        ? `${baseUrl}/download-csv?${params.toString()}`
        : `${baseUrl}/download-csv`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to Download");
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "Weekly_Offerings.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      throw new Error("Failed to Download");
    }
  };
  return (
    <div className="action-buttons">
      <div className="col-xs-6 col-sm-6 col-md-3">
        <button
          className="btn btn-block td-btn-secondary-clear clear-btn"
          onClick={handlePrint}
          data-testid="print"
        >
          <span className="td-icon td-icon-printer"></span>
          <TranslateComponent label={PRINT} />
        </button>
      </div>
      <div className="col-xs-6 col-sm-6 col-md-3">
        <button
          data-testid="download"
          className="btn btn-block td-btn-secondary-clear clear-btn"
          onClick={handleDownload}
        >
          <span className="td-icon td-icon-download"></span>
          <TranslateComponent label={DOWNLOAD_CSV} />
        </button>
      </div>
    </div>
  );
}
